<template>
    <div class="tools">
        <a href="javascript:;" @click="openAssistant" class="tool" title="在线客服"><img src="/assets/images/assistant-white.png" alt="在线客服"></a>
    </div>
</template>
<script>
export default {

    methods: {
        'openAssistant': function () {
            document.querySelector('#nb_invite_wrap').click()
        }
    }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// tools.vue?6f76c902